import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DATE_FORMAT, ECHART_DATE_FORMAT, GMT_IST_DIFFERENCE, MOMENT_COMPLETE_TIME, THROTTLER_MAP, Utils } from '@app/_helpers';
import { ConfigurationService, QUOTE_UPDATE_TYPE, QuoteStoreService } from '@app/_shared';
import { AlgowisePositionDataService } from '@app/_shared/providers/algowise-position-data/algowise-position-data.service';
import { NormalThrottler } from '@app/app.models';
import { BriefPortfolioModel } from '@app/modules/trading/modules/market-place/providers/market-place/market-place.models';
import { orderBy } from 'lodash-es';
import * as moment from 'moment';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AffiliateFundsResponse, AffiliateProfile, LeadStatusReportResponse } from '../interfaces/profile.interface';
import { AffiliateClientType, AffiliateFundsRequest, SortDirection } from '../structs/affiliate.structs';
import { AffiliateFundRow } from './affilaite.model';

@Injectable({
    providedIn: 'root'
})
export class AffiliateService {
    affilateFundVsStgIDMap = new Map<string, AffiliateFundRow>();

    affilateFundsSet = new Set<AffiliateFundRow>()
    dataSource = new Map<string, LeadStatusReportResponse[]>();
    throttler = new NormalThrottler(THROTTLER_MAP.AFFILIATE_FUNDS_BOOK, this.quoteStore, QUOTE_UPDATE_TYPE.QUOTE);


    constructor(
        private http: HttpClient,
        private confService: ConfigurationService,
        private algoPositionService: AlgowisePositionDataService,
        private quoteStore: QuoteStoreService,
    ) { }

    getAffiliateProfile() {
        const url = this.confService.applicationUrls.affiliateProfile;
        return this.http.get<AffiliateProfile>(url);
    }

    getLeads(is_dealer: boolean = false, sort_by: string = 'date', sort_direction = SortDirection.ASC) {
        const key = Utils.getJoinedString();
        if (this.dataSource.has(key)) {
            return of(this.dataSource.get(key));
        } else {
            const url = is_dealer ? this.confService.applicationUrls.dealerClientsList : this.confService.applicationUrls.affiliateLeads;

            return this.http.get<LeadStatusReportResponse[]>(url, {
                params: {
                    sort_by: sort_by, sort_direction: sort_direction
                }
            }).pipe(map(res => {
                let ret = res.map(el => {
                    let ret = el;
                    ret.login_source = (el.referral_code ? AffiliateClientType['bpClient'] : AffiliateClientType[el.login_source]);
                    ret.date = moment(ret.date).subtract({ milliseconds: GMT_IST_DIFFERENCE }).format(`${ECHART_DATE_FORMAT} ${MOMENT_COMPLETE_TIME}`);
                    return ret;
                })
                this.dataSource.set(key, ret);
                return ret;
            }))
        }
    }

    getFundsData(request: AffiliateFundsRequest) {
        const url = this.confService.applicationUrls.affiliateFunds;
        return this.http.get<AffiliateFundsResponse>(url, {
            params: { ...request } as any
        }).pipe(map((res) => {
            const funds = res.margin_blocked;
            const portfolios = res.strategies.map(r => new BriefPortfolioModel(r));
            const ucc = res.ucc;
            const strategyWisePnl = res.strategy_wise_pnl;
            this.affilateFundsSet.clear();

            funds.forEach((fund) => {
                const key = fund.token_id + moment(fund.created_at['$date']).subtract(GMT_IST_DIFFERENCE).format(DATE_FORMAT);
                const fundObj = new AffiliateFundRow(fund);
                this.affilateFundVsStgIDMap.set(key.toString(), fundObj);
                this.affilateFundsSet.add(fundObj);
            })

            portfolios.forEach((portfolio) => {
                const fundsSet: Set<AffiliateFundRow> = new Set();
                var fundObj: AffiliateFundRow;
                const key = portfolio.tokenID + moment(portfolio.deployed_on).format(DATE_FORMAT);
                if (portfolio.tokenID && key && this.affilateFundVsStgIDMap.has(key)) {
                    fundObj = this.affilateFundVsStgIDMap.get(key);
                    fundObj.fillStrategyDetails(portfolio, ucc, strategyWisePnl[portfolio.tokenID]);
                } else {
                    fundObj = new AffiliateFundRow(null, portfolio, ucc, strategyWisePnl[portfolio.tokenID]);
                    this.affilateFundsSet.add(fundObj);
                }

                fundObj.positionObjects = this.algoPositionService.getPortfolioLevelPositions(portfolio.uniquePortfolioID);
                fundsSet.add(fundObj);
                this.algoPositionService.portfolioIdFundsObjMap.set(portfolio.portfolioID, fundObj);
                // this.algoPositionService.symbolIdFundsObjMap.set(Utils.getJoinedString(portfolio.algo.symbols[0].market_id, portfolio.algo.symbols[0].security_id), fundsSet)
                this.affilateFundVsStgIDMap.set(portfolio.uniquePortfolioID, fundObj);
            })
            return orderBy(Array.from(this.affilateFundsSet), ['dateUnix'], 'desc');
        }))
    }

}
